import { css } from 'styled-components';

const sizes = {
	xxxl: '83px',
	xxl: '33px',
	xl: '28px',
	l: '23px',
	m: '19px',
	s: '16px',
	xs: '13px',
	xxs: '11px',
	xxxs: '9px',
};

const weights = {
	bold: 700,
	medium: 500,
	regular: 400,
	light: 300,
};

// H0 (Home)
export const xxxlMedium = css`
	font-size: ${sizes.xxxl};
	font-weight: ${weights.medium};
	letter-spacing: 0.75px;
	line-height: 83px;
`;

// H1
export const xxlMedium = css`
	font-size: ${sizes.xxl};
	font-weight: ${weights.medium};
	letter-spacing: 0.3px;
	line-height: 41px;
`;

// H2
export const xlBold = css`
	font-size: ${sizes.xl};
	font-weight: ${weights.bold};
	letter-spacing: 0.3px;
	line-height: 35px;
`;

// H3
export const lBold = css`
	font-size: ${sizes.l};
	font-weight: ${weights.bold};
	letter-spacing: 0.5px;
	line-height: 31px;
`;

// Main navigation
export const lMedium = css`
	font-size: ${sizes.l};
	font-weight: ${weights.medium};
	letter-spacing: normal;
	line-height: 31px;
`;

// H4
export const mMedium = css`
	font-size: ${sizes.m};
	font-weight: ${weights.medium};
	letter-spacing: normal;
	line-height: 27px;
`;

// Paragraph regular (Root)
export const sRegular = css`
	font-size: ${sizes.s};
	font-weight: ${weights.regular};
	letter-spacing: 0.3px;
	line-height: 24px;
`;

// Paragraph small
export const xsRegular = css`
	font-size: ${sizes.xs};
	font-weight: ${weights.regular};
	letter-spacing: 0.8px;
	line-height: 21px;
`;

// Button / Tab / Dropdown
export const xsMediumUppercase = css`
	font-size: ${sizes.xs};
	font-weight: ${weights.medium};
	letter-spacing: 0.3px;
	line-height: 13px;
	text-transform: uppercase;
`;

// Overline
export const xxsRegularUppercase = css`
	font-size: ${sizes.xxs};
	font-weight: ${weights.regular};
	letter-spacing: 0.8px;
	line-height: 13px;
	text-transform: uppercase;
`;
export const xxxsRegularUppercase = css`
	font-size: ${sizes.xxxs};
	font-weight: ${weights.regular};
	letter-spacing: 0.8px;
	line-height: 13px;
	text-transform: uppercase;
`;

// Caption
export const xxsRegular = css`
	font-size: ${sizes.xxs};
	font-weight: ${weights.regular};
	letter-spacing: normal;
	line-height: 13px;
`;
